/// Mirrors `crates/domain/src/lawyers/services/lockable_fields.rs`. The two
/// lists must stay column-for-column in sync; any drift surfaces as a 403
/// from the backend.
export const LOCKED_COLUMNS: ReadonlyArray<string> = [
  'id',
  'firm_id',
  'legal_training_term',
  'is_representative',
  'sales_grade',
  'last_contact_at',
  'source',
  'confidence',
  'created_at',
  'updated_at',
];

export const SERVER_EDITABLE_LOCKED_COLUMNS: ReadonlyArray<string> = [];

export function isLocked(column: string): boolean {
  return (
    LOCKED_COLUMNS.includes(column) &&
    !SERVER_EDITABLE_LOCKED_COLUMNS.includes(column)
  );
}
